import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("dft_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

let _402ToastShown = false;

api.interceptors.response.use(
    (r) => r,
    (err) => {
        const status = err.response?.status;
        if (status === 401 && window.location.pathname !== "/login" && window.location.pathname !== "/register") {
            localStorage.removeItem("dft_token");
            window.location.href = "/login";
        }
        if (status === 402 && !_402ToastShown) {
            _402ToastShown = true;
            toast.error("Your subscription has expired. Please update your billing.", {
                duration: 8000,
                action: { label: "Billing", onClick: () => { window.location.href = "/billing"; } },
                onDismiss: () => { _402ToastShown = false; },
                onAutoClose: () => { _402ToastShown = false; },
            });
        }
        return Promise.reject(err);
    }
);

export function formatApiErrorDetail(detail) {
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

export const CURRENCIES = [
    { code: "GBP", symbol: "£" },
    { code: "USD", symbol: "$" },
    { code: "EUR", symbol: "€" },
    { code: "CHF", symbol: "CHF" },
    { code: "JPY", symbol: "¥" },
    { code: "AUD", symbol: "A$" },
    { code: "CAD", symbol: "C$" },
    { code: "INR", symbol: "₹" },
];

export function currencySymbol(code) {
    return CURRENCIES.find((c) => c.code === code)?.symbol || code;
}

export function fmtMoney(amount, code = "GBP") {
    const n = Number(amount || 0);
    return `${currencySymbol(code)}${n.toLocaleString(undefined, { maximumFractionDigits: 0 })}`;
}

export function fmtDateRelative(iso) {
    if (!iso) return "—";
    const d = new Date(iso);
    const diff = (Date.now() - d.getTime()) / 1000;
    if (diff < 60) return "just now";
    if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
    if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
    if (diff < 86400 * 30) return `${Math.floor(diff / 86400)}d ago`;
    return d.toLocaleDateString();
}
